<pm-widget-base-wrapper [isLoading]="isLoading" [name]="name">
  <ng-template
    pmWidgetTitle
    infoTooltipText="
      {{ 'RESULT.INSIGHTS.WIDGETS.TREND_ANALYSIS.TOOLTIP' | translate }}
    "
  >
    {{ 'RESULT.INSIGHTS.WIDGETS.TREND_ANALYSIS.TITLE' | translate }}
  </ng-template>

  <ng-template pmWidgetHeader>
    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER">
      <pm-form-input-select
        [allowSearching]="true"
        [formControl]="selectedFilterFormControl"
        [data]="filterOptionsForSelect()"
      />
    </pm-form-field>

    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_DATASET">
      <pm-form-input-select
        [multiSelect]="true"
        [clearable]="true"
        [allowUnselect]="true"
        [allowSelectAll]="true"
        [formControl]="selectedValuesFormControl"
        [selectableItemsLimit]="MAX_NUMBER_OF_SELECTIONS"
        labelKey="label"
        propertyKey="label"
        [data]="filterValuesForSelect()"
      />
    </pm-form-field>
  </ng-template>
  <ng-template pmWidgetContent>
    @if (datasetHasValidDataPoints) {
      <highcharts-chart
        id="year-to-date-trend-chart"
        [(update)]="chartUpdated"
        (chartInstance)="setChartInstance($event)"
        [oneToOne]="true"
        [options]="chartOptions()"
        class="!w-full !h-full !block"
      >
      </highcharts-chart>
    } @else {
      <div class="flex justify-center items-center h-full text-center p-4">
        <pm-h3>
          {{
            'RESULT.INSIGHTS.WIDGETS.TREND_ANALYSIS.DATASET_INVALID' | translate
          }}
        </pm-h3>
      </div>
    }
  </ng-template>
  <ng-template pmWidgetActions>
    @if (isDialogInstance) {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.EXIT_FULL_SCREEN_TOOLTIP'"
        (handleClick)="exitFullScreen()"
        [icon]="scanIcon"
      />
    } @else {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.FULL_SCREEN_TOOLTIP'"
        [icon]="scanIcon"
        (handleClick)="
          showFullScreen(YearToDateTrendWidgetComponent, {
            targetUnit: this.targetUnit,
            filterColumn: this.selectedFilterFormControl.getRawValue().column,
            filterOptions: this.selectedValuesFormControl.getRawValue(),
          })
        "
      />
    }
  </ng-template>
</pm-widget-base-wrapper>
